import moment from 'moment'
import 'moment/locale/pt-br'

export function validateCPF(value) {
    // remove caracteres não numéricos
    value = value.replace(/\D/g, '')

    // verifica se o value tem 11 dígitos
    if (value.length !== 11) {
        return 'Informe um CPF válido!'
    }

    // verifica se todos os dígitos são iguais
    if (/(\d)\1{10}/.test(value)) {
        return 'Informe um CPF válido!'
    }

    let sum = 0
    let remainder, i

    // calcula o primeiro dígito verificador
    for (i = 1; i <= 9; i++) sum = sum + parseInt(value.substring(i - 1, i)) * (11 - i)
    remainder = (sum * 10) % 11
    if ((remainder === 10) || (remainder === 11)) remainder = 0
    if (remainder !== parseInt(value.charAt(9))) return 'Informe um CPF válido!'

    // calcula o segundo dígito verificador
    sum = 0
    for (i = 1; i <= 10; i++) sum = sum + parseInt(value.substring(i - 1, i)) * (12 - i)
    remainder = (sum * 10) % 11
    if ((remainder === 10) || (remainder === 11)) remainder = 0
    if (remainder !== parseInt(value.charAt(10))) return 'Informe um CPF válido!'

    return true
}

export function validateCNPJ(value) {
    // remove caracteres não numéricos
    value = value.replace(/\D/g, '');

    // verifica se o CNPJ tem 14 dígitos
    if (value.length !== 14) {
        return 'Informe um CNPJ válido!'
    }

    // verifica se todos os dígitos são iguais
    if (/(\d)\1{13}/.test(value)) {
        return 'Informe um CNPJ válido!'
    }

    let i, x, y

    let a = []
    let n = 0
    var d = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    // calcula o primeiro dígito verificador
    for (i = 0; i < 12; i++) {
        a[i] = value.charAt(i)
        n += a[i] * d[i + 1]
    }
    if ((x = n % 11) < 2) { a[12] = 0 } else { a[12] = 11 - x }

    // calcula o segundo dígito verificador
    n = 0
    for (y = 0; y < 13; y++) {
        n += (a[y] * d[y])
    }
    if ((x = n % 11) < 2) { a[13] = 0; } else { a[13] = 11 - x }

    // compara os dois dígitos calculados
    if ((parseInt(value.charAt(12)) !== a[12]) || (parseInt(value.charAt(13)) !== a[13])) {
        return 'Informe um CNPJ válido!'
    }

    return true
}

export function validateDate(value) {
    console.log('dsdsd')
    console.log(value)

    var date = moment(value, 'DD/MM/YYYY')
    return date.isValid() ? true : 'Informe uma data válida!'
}